import { Row, Col, Button } from "antd";
import { motion } from "motion/react";

const ease = [0.22, 1, 0.36, 1];

export default function Contact() {
  return (
    <section className="py-24 bg-[#faf6ee] mt-4 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <Row gutter={[64, 48]}>
          {/* Left Side */}
          <Col xs={24} lg={10}>
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
              variants={{ hidden: { opacity: 0 }, visible: { opacity: 1, transition: { staggerChildren: 0.15 } } }}
              className="space-y-10"
            >
              <motion.div
                variants={{ hidden: { opacity: 0, x: -30 }, visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease } } }}
              >
                <h2 className="uppercase md:text-xl text-base font-extrabold text-brand-gold">
                  Get in Touch
                </h2>
                <h3 className="text-4xl font-bold text-brand-forest">Visit Our Clinic</h3>
              </motion.div>

              <div className="space-y-8">
                {/* first address */}
                <motion.div
                  variants={{ hidden: { opacity: 0, x: -30 }, visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease } } }}
                >
                  <h4 className="text-[11px] uppercase tracking-widest font-bold text-gray-500 mb-2">Address 1</h4>
                  <p className="text-brand-forest font-medium leading-7">
                    VedaNova AyurMed Pvt. Ltd., 
                    <br />
                    Seawoods,
                    <br />
                    Navi Mumbai 400706
                  </p>
                </motion.div>

                {/* second address */}

                <motion.div
                  variants={{ hidden: { opacity: 0, x: -30 }, visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease } } }}
                >
                  <h4 className="text-[11px] uppercase tracking-widest font-bold text-gray-500 mb-2">Address 2</h4>
                  <p className="text-brand-forest font-medium leading-7">
                    VedaNova Pvt. Ltd FF15,  
                    <br />
                    Landmark Business Centre,
                    <br />
                    Satara - 415001
                  </p>
                </motion.div>

                {/* third address */ }
                <motion.div
                  variants={{ hidden: { opacity: 0, x: -30 }, visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease } } }}
                >
                  <h4 className="text-[11px] uppercase tracking-widest font-bold text-gray-500 mb-2">Address 3</h4>
                  <p className="text-brand-forest font-medium leading-7">
                    Coming soon in  
                    <br />
                    Kolhapur, Pune
                    <br />
                  </p>
                </motion.div>

                <motion.div
                  variants={{ hidden: { opacity: 0, x: -30 }, visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease } } }}
                >
                  <h4 className="text-[11px] uppercase tracking-widest font-bold text-gray-500 mb-2">Contact</h4>
                  <p className="text-brand-forest font-medium leading-7">
                    +91 90281 56566  
                    <br />
                   contact@vedanova.com
                  </p>
                </motion.div>

                <motion.div
                  variants={{ hidden: { opacity: 0, x: -30 }, visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease } } }}
                >
                  <h4 className="text-[11px] uppercase tracking-widest font-bold text-gray-500 mb-2">Hours</h4>
                  <p className="text-brand-forest font-medium leading-7">
                    Mon – Sat : 9:00 AM – 8:00 PM
                    <br />
                    Sunday : Closed
                  </p>
                </motion.div>
              </div>
            </motion.div>
          </Col>

          {/* Right Side - Google Map */}
          <Col xs={24} lg={14}>
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1, ease }}
            >
              {/* First Google Map - Om Ganesh Towers */}
<div className="rounded-2xl overflow-hidden shadow-2xl border border-brand-lightgold h-[350px]">
  <iframe
    title="Om Ganesh Towers"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3771.041680198402!2d73.0076045!3d19.0618683!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c14fe68bfffe%3A0x31b943f65f3ec736!2sOm%20Ganesh%20Towers%2C%20Sector%201%2C%20Sanpada%2C%20Navi%20Mumbai%2C%20Maharashtra%20400705!5e1!3m2!1sen!2sin!5m2!1sen!2sin"
    width="100%"
    height="100%"
    style={{ border: 0 }}
    allowFullScreen
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  ></iframe>
</div>

                  {/* second google map */}
              <div className="rounded-2xl overflow-hidden shadow-2xl border border-brand-lightgold h-[350px] mt-4 ">
                <iframe
                  title="Veda Nova Clinic"
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d9383.688402049787!2d73.99981123652!3d17.698040836873773!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc239d0370995d3%3A0xf53ad463ac72fb5!2sLandmark%20Towers!5e1!3m2!1sen!2sin!4v1785489173136!5m2!1sen!2sin"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
              <div className="flex justify-center mt-8">
                <a
                  href="https://maps.app.goo.gl/fpeGhdi4MrKSLR8Z9"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button
                    size="large"
                    className="!bg-brand-forest !text-white !border-none !font-semibold hover:!bg-brand-gold !shadow-lg"
                  >
                    View on Google Maps
                  </Button>
                </a>
              </div>
            </motion.div>
          </Col>
        </Row>
      </div>
    </section>
  );
}
